import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { EditCellDropdown } from 'shared/components';
import { useDropdownOptions } from 'shared/queries';

export function ImportanceDropdown(params: GridRenderCellParams<string>) {
  const { data } = useDropdownOptions('commodity-importance');

  if (data !== undefined) {
    return <EditCellDropdown data={data} params={params}></EditCellDropdown>;
  } else {
    return <Box>Loading...</Box>;
  }
}
